export default class TwoColumnCTA {
    constructor() {
        if($('.two-column-cta .two-column-cta-title')[0]) {
            $('.two-column-cta .two-column-cta-title').matchHeight({ byRow: true });
        }
        if($('.two-column-cta .two-column-cta-copy')[0]) {
            $('.two-column-cta .two-column-cta-copy').matchHeight({ byRow: true });
        }
    }
}

new TwoColumnCTA();


// WEBPACK FOOTER //
// ../views/modules/two-column-c-t-a/assets/js/two-column-c-t-a.js